import styled from '@emotion/styled';
import { Button, FormControl, MenuItem, Select } from '@mui/material';

const ITEM_HEIGHT = 36;
const ITEM_PADDING_TOP = 6;

export const ComboBoxContainer = styled('div')({});

export const FormControlStyles = styled(FormControl)({
  width: '360px',
  height: '40px',
  marginBottom: '24px',
  '&:hover': {
    '& .MuiInputLabel-root': {
      color: '#5F65F6'
    }
  },
  '& .MuiInputLabel-root': {
    '&.Mui-focused': {
      color: '#5F65F6'
    }
  }
});

export const StyledSelect = styled(Select)({
  fontSize: '14px',
  fontFamily: 'Open Sans',
  width: '264px',
  '&.MuiOutlinedInput-root': {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: '400px'
  },
  maxHeight: 48 * 5,
  '&.Mui-focused': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '1px',
      borderColor: '#5F65F6'
    }
  },
  '&:hover': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#5F65F6'
    }
  }
});

export const StyledMenuItem = styled(MenuItem)({
  fontWeight: '400px',
  fontSize: '14px',
  fontFamily: 'Open Sans'
});

export const AddButton = styled(Button)({
  marginLeft: '14px',
  marginBottom: '2.5px',
  color: '#3F51B5',
  fontSize: '14px',
  fontFamily: 'Open Sans',
  fontWeight: 600,
  borderRadius: '10px',
  width: '61px',
  height: '37.5px',
  border: '1px solid rgba(63, 81, 181, 0.5)',
  textTransform: 'none',
  '&:hover': {
    color: '#3F51B5',
    backgroundColor: '#FFF'
  }
});

export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
    }
  }
};
